import axios from 'axios';
import _ from 'lodash';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';

/**
 * Resends an activation request for a given username by email.
 * @param {String} options.username - The current username to resend activation request.
 * @param {String} options.email - The current user email.
 * @returns {Promise<undefined>}
 */
export const resend = async({ username, email }) => {
    try {
        const url = pathfinder('reactivate');
        await axios.post(url, {
            username,
            email
        });
    } catch (error) {
        logger.error(error, { description: 'resend_activation failed' });

        const message = _.get(error, 'response.data.error', '');
        throw new Error(message);
    }
};
